module.exports = __webpack_public_path__ + "static/media/002-app.ba4dc2e6.svg";